import ReprocessingIcon from 'components/ReusableComponents/Icons/ReprocessingIcon'
import { useEffect, useState } from 'react'
import maintenanceApi from 'services/api/maintenance'

import styles from './DataIsReprocessingBar.module.scss'

const DataIsReprocessingBar = ({ marginBottom = 0, marginTop = 25 }) => {
  const [isActive, setIsActive] = useState(true)

  useEffect(() => {
    maintenanceApi
      .getIsActiveByPath(document.location.pathname)
      .then(data => {
        setIsActive(data.isActive)
      })
      .catch(error => {
        console.warn(error)
      })
  }, [])

  if (isActive) return null

  return null

  return (
    <div className={styles.bar} style={{ marginBottom, marginTop }}>
      <div className={styles.iconHolder}>
        <ReprocessingIcon />
      </div>
      <div className={styles.textHolder}>
        <p className={styles.title}>
          Data on this page is being updated. Please check back shortly for updated
          information.
        </p>
      </div>
    </div>
  )
}

export default DataIsReprocessingBar
